import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import auth from './auth';
import shoppingCart from './shoppingCart';
import products from './products';
import layout from './layout';
import addresses from './addresses';
import bonuses from './bonuses';
import orders from './orders';
import users from './users';
import categories from './categories';


export default (history) => combineReducers({
    router: connectRouter(history),
    auth,
    shoppingCart,
    products,
    layout,
    addresses,
    orders,
    users,
    categories,
    bonuses
});